import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataRassco: ApartmentEntry[] = [
  {
    building: 'A',
    number: 1,
    type: 'a-5',
    floor: 5,
    rooms: 3,
    area: 62,
    balconyArea: 118,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_a-5_select_floor5',
    nrId: 1,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanA5',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 4,
    type: 'd-5',
    floor: 5,
    rooms: 3,
    area: 83,
    balconyArea: 58,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d-5_select_floor5',
    nrId: 2,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD5',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 7,
    type: 'g-5',
    floor: 5,
    rooms: 3,
    area: 73,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g-5_select_floor5',
    nrId: 3,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG5',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 8,
    type: 'h-5',
    floor: 5,
    rooms: 2,
    area: 63,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h-5_select_floor5',
    nrId: 4,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH5',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 9,
    type: 'i-5',
    floor: 5,
    rooms: 3,
    area: 76,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i-5_select_floor5',
    nrId: 5,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI5',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 10,
    type: 'a',
    floor: 6,
    rooms: 3,
    area: 62,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_a_select_floor6',
    nrId: 6,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanA',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 13,
    type: 'd',
    floor: 6,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor6',
    nrId: 7,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 14,
    type: 'e',
    floor: 6,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor6',
    nrId: 8,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 15,
    type: 'f',
    floor: 6,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor6',
    nrId: 9,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 21,
    type: 'l',
    floor: 6,
    rooms: 3,
    area: 64,
    balconyArea: 6,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_l_select_floor6',
    nrId: 10,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanL',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 25,
    type: 'd',
    floor: 7,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor7',
    nrId: 11,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 26,
    type: 'e',
    floor: 7,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor7',
    nrId: 12,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 27,
    type: 'f',
    floor: 7,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor7',
    nrId: 13,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 29,
    type: 'h',
    floor: 7,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor7',
    nrId: 14,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 30,
    type: 'i',
    floor: 7,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor7',
    nrId: 15,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 31,
    type: 'j',
    floor: 7,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor7',
    nrId: 16,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 32,
    type: 'k',
    floor: 7,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor7',
    nrId: 17,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 33,
    type: 'l',
    floor: 7,
    rooms: 3,
    area: 64,
    balconyArea: 6,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_l_select_floor7',
    nrId: 18,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanL',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 37,
    type: 'd',
    floor: 8,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor8',
    nrId: 19,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 38,
    type: 'e',
    floor: 8,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor8',
    nrId: 20,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 39,
    type: 'f',
    floor: 8,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor8',
    nrId: 21,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 40,
    type: 'g',
    floor: 8,
    rooms: 3,
    area: 74,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g_select_floor8',
    nrId: 22,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 41,
    type: 'h',
    floor: 8,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor8',
    nrId: 23,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 42,
    type: 'i',
    floor: 8,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor8',
    nrId: 24,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 49,
    type: 'd',
    floor: 9,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor9',
    nrId: 25,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 50,
    type: 'e',
    floor: 9,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor9',
    nrId: 26,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 51,
    type: 'f',
    floor: 9,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor9',
    nrId: 27,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 53,
    type: 'h',
    floor: 9,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor9',
    nrId: 28,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 54,
    type: 'i',
    floor: 9,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor9',
    nrId: 29,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 55,
    type: 'j',
    floor: 9,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor9',
    nrId: 30,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 56,
    type: 'k',
    floor: 9,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor9',
    nrId: 31,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 59,
    type: 'b',
    floor: 10,
    rooms: 3,
    area: 63,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_b_select_floor10',
    nrId: 32,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 60,
    type: 'c',
    floor: 10,
    rooms: 2,
    area: 55,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_c_select_floor10',
    nrId: 33,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 61,
    type: 'd',
    floor: 10,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor10',
    nrId: 34,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 62,
    type: 'e',
    floor: 10,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor10',
    nrId: 35,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 63,
    type: 'f',
    floor: 10,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor10',
    nrId: 36,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 64,
    type: 'g',
    floor: 10,
    rooms: 3,
    area: 74,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g_select_floor10',
    nrId: 37,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 65,
    type: 'h',
    floor: 10,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor10',
    nrId: 38,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 66,
    type: 'i',
    floor: 10,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor10',
    nrId: 39,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 67,
    type: 'j',
    floor: 10,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor10',
    nrId: 40,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 68,
    type: 'k',
    floor: 10,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor10',
    nrId: 41,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 70,
    type: 'a',
    floor: 11,
    rooms: 3,
    area: 62,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_a_select_floor11',
    nrId: 42,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanA',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 72,
    type: 'c',
    floor: 11,
    rooms: 2,
    area: 55,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_c_select_floor11',
    nrId: 43,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 73,
    type: 'd',
    floor: 11,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor11',
    nrId: 44,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 74,
    type: 'e',
    floor: 11,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor11',
    nrId: 45,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 75,
    type: 'f',
    floor: 11,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor11',
    nrId: 46,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 76,
    type: 'g',
    floor: 11,
    rooms: 3,
    area: 74,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g_select_floor11',
    nrId: 47,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 77,
    type: 'h',
    floor: 11,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor11',
    nrId: 48,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 78,
    type: 'i',
    floor: 11,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor11',
    nrId: 49,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 79,
    type: 'j',
    floor: 11,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor11',
    nrId: 50,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 80,
    type: 'k',
    floor: 11,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor11',
    nrId: 51,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 82,
    type: 'a',
    floor: 12,
    rooms: 3,
    area: 62,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_a_select_floor12',
    nrId: 52,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanA',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 84,
    type: 'c',
    floor: 12,
    rooms: 2,
    area: 55,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_c_select_floor12',
    nrId: 53,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 85,
    type: 'd',
    floor: 12,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor12',
    nrId: 54,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 86,
    type: 'e',
    floor: 12,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor12',
    nrId: 55,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 87,
    type: 'f',
    floor: 12,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor12',
    nrId: 56,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 88,
    type: 'g',
    floor: 12,
    rooms: 3,
    area: 74,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g_select_floor12',
    nrId: 57,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 89,
    type: 'h',
    floor: 12,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor12',
    nrId: 58,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 90,
    type: 'i',
    floor: 12,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor12',
    nrId: 59,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 91,
    type: 'j',
    floor: 12,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor12',
    nrId: 60,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 92,
    type: 'k',
    floor: 12,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor12',
    nrId: 61,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 94,
    type: 'a',
    floor: 13,
    rooms: 3,
    area: 62,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_a_select_floor13',
    nrId: 62,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanA',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 96,
    type: 'c',
    floor: 13,
    rooms: 2,
    area: 55,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_c_select_floor13',
    nrId: 63,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 97,
    type: 'd',
    floor: 13,
    rooms: 3,
    area: 83,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_d_select_floor13',
    nrId: 64,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanD',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 98,
    type: 'e',
    floor: 13,
    rooms: 3,
    area: 82,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_e_select_floor13',
    nrId: 65,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 99,
    type: 'f',
    floor: 13,
    rooms: 3,
    area: 71,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_f_select_floor13',
    nrId: 66,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanF',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 100,
    type: 'g',
    floor: 13,
    rooms: 3,
    area: 74,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_g_select_floor13',
    nrId: 67,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanG',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 101,
    type: 'h',
    floor: 13,
    rooms: 2,
    area: 60,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_h_select_floor13',
    nrId: 68,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanH',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 102,
    type: 'i',
    floor: 13,
    rooms: 3,
    area: 80,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_i_select_floor13',
    nrId: 69,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanI',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 103,
    type: 'j',
    floor: 13,
    rooms: 3,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_j_select_floor13',
    nrId: 70,
    tourUrl: 'https://my.treedis.com/tour/j5',
    galleryType: 'galleryJ',
    galleryCount: 7,
    floorPlanImage: 'floorplanJ',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 104,
    type: 'k',
    floor: 13,
    rooms: 3,
    area: 75,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_k_select_floor13',
    nrId: 71,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanK',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 106,
    type: 'AWS-14',
    floor: 14,
    rooms: 5,
    area: 121,
    balconyArea: 144,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS-14_select_floor14',
    nrId: 72,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWS14',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 109,
    type: 'ANE',
    floor: 14,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor14',
    nrId: 73,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 111,
    type: 'ANW-14',
    floor: 14,
    rooms: 6,
    area: 135,
    balconyArea: 136,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW-14_select_floor14',
    nrId: 74,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW14',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 115,
    type: 'ANE',
    floor: 15,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor15',
    nrId: 75,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 121,
    type: 'ANE',
    floor: 16,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor16',
    nrId: 76,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 127,
    type: 'ANE',
    floor: 17,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor17',
    nrId: 77,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 133,
    type: 'ANE',
    floor: 18,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor18',
    nrId: 78,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 139,
    type: 'ANE',
    floor: 19,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor19',
    nrId: 79,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 145,
    type: 'ANE',
    floor: 20,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor20',
    nrId: 80,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 146,
    type: 'AN',
    floor: 20,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor20',
    nrId: 81,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 151,
    type: 'ANE',
    floor: 21,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor21',
    nrId: 82,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 157,
    type: 'ANE',
    floor: 22,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor22',
    nrId: 83,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 159,
    type: 'ANW',
    floor: 22,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW_select_floor22',
    nrId: 84,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 162,
    type: 'ASE',
    floor: 23,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE_select_floor23',
    nrId: 85,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 163,
    type: 'ANE',
    floor: 23,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor23',
    nrId: 86,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 165,
    type: 'ANW',
    floor: 23,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW_select_floor23',
    nrId: 87,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 166,
    type: 'AWS',
    floor: 24,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor24',
    nrId: 88,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 168,
    type: 'ASE',
    floor: 24,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE_select_floor24',
    nrId: 89,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 169,
    type: 'ANE',
    floor: 24,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor24',
    nrId: 90,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 175,
    type: 'ANE',
    floor: 25,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor25',
    nrId: 91,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 176,
    type: 'AN',
    floor: 25,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor25',
    nrId: 92,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 180,
    type: 'AES',
    floor: 26,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AES_select_floor26',
    nrId: 93,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAES36',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 181,
    type: 'ANE',
    floor: 26,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor26',
    nrId: 94,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 184,
    type: 'AWS',
    floor: 27,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor27',
    nrId: 95,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 187,
    type: 'ANE',
    floor: 27,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor27',
    nrId: 96,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 188,
    type: 'AN',
    floor: 27,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor27',
    nrId: 97,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 190,
    type: 'AWS',
    floor: 28,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor28',
    nrId: 98,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 192,
    type: 'ASE',
    floor: 28,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE_select_floor28',
    nrId: 99,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 193,
    type: 'ANE',
    floor: 28,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor28',
    nrId: 100,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 194,
    type: 'AN',
    floor: 28,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor28',
    nrId: 101,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 195,
    type: 'ANW',
    floor: 28,
    rooms: 6,
    area: 135,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW_select_floor28',
    nrId: 102,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 196,
    type: 'AWS',
    floor: 29,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor29',
    nrId: 103,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 199,
    type: 'ANE',
    floor: 29,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor29',
    nrId: 104,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 200,
    type: 'AN',
    floor: 29,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor29',
    nrId: 105,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 202,
    type: 'AWS',
    floor: 30,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor30',
    nrId: 106,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 205,
    type: 'ANE',
    floor: 30,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor30',
    nrId: 107,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 206,
    type: 'AN',
    floor: 30,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor30',
    nrId: 108,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 208,
    type: 'AWS',
    floor: 31,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor31',
    nrId: 109,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 210,
    type: 'ASE-31-33',
    floor: 31,
    rooms: 6,
    area: 135,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE-31-33_select_floor31',
    nrId: 110,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 211,
    type: 'ANE',
    floor: 31,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor31',
    nrId: 111,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 212,
    type: 'AN',
    floor: 31,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor31',
    nrId: 112,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 214,
    type: 'AWS',
    floor: 32,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS_select_floor32',
    nrId: 113,
    tourUrl: 'https://my.treedis.com/tour/aws',
    galleryType: 'galleryAWS',
    galleryCount: 20,
    floorPlanImage: 'floorplanAWS',
    hasVideo: true,
  },
  {
    building: 'A',
    number: 216,
    type: 'ASE-31-33',
    floor: 32,
    rooms: 6,
    area: 135,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE-31-33_select_floor32',
    nrId: 114,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 217,
    type: 'ANE',
    floor: 32,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor32',
    nrId: 115,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 218,
    type: 'AN',
    floor: 32,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor32',
    nrId: 116,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 219,
    type: 'ANW-32-33',
    floor: 32,
    rooms: 6,
    area: 135,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW-32-33_select_floor32',
    nrId: 117,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 221,
    type: 'AS',
    floor: 33,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AS_select_floor33',
    nrId: 118,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAS',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 222,
    type: 'ASE-31-33',
    floor: 33,
    rooms: 6,
    area: 135,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE-31-33_select_floor33',
    nrId: 119,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 223,
    type: 'ANE',
    floor: 33,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE_select_floor33',
    nrId: 120,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 224,
    type: 'AN',
    floor: 33,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AN_select_floor33',
    nrId: 121,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAN',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 225,
    type: 'ANW-32-33',
    floor: 33,
    rooms: 6,
    area: 135,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANW-32-33_select_floor33',
    nrId: 122,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANW',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 226,
    type: 'AWS-34',
    floor: 34,
    rooms: 5,
    area: 142,
    balconyArea: 36,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS-34_select_floor34',
    nrId: 123,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWS34',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 227,
    type: 'AWNE-34',
    floor: 34,
    rooms: 6,
    area: 198,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWNE-34_select_floor34',
    nrId: 124,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWNE34',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 228,
    type: 'ANE-34-35',
    floor: 34,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE-34-35_select_floor34',
    nrId: 125,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE34-35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 229,
    type: 'ASE-34-35',
    floor: 34,
    rooms: 6,
    area: 135,
    balconyArea: 21,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE-34-35_select_floor34',
    nrId: 126,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE34-35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 230,
    type: 'AS',
    floor: 34,
    rooms: 4,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AS_select_floor34',
    nrId: 127,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAS',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 231,
    type: 'AWN-35',
    floor: 35,
    rooms: 6,
    area: 188,
    balconyArea: 58,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWN-35_select_floor35',
    nrId: 128,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWN35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 232,
    type: 'ANE-34-35',
    floor: 35,
    rooms: 5,
    area: 121,
    balconyArea: 22,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ANE-34-35_select_floor35',
    nrId: 129,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanANE34-35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 233,
    type: 'ASE-34-35',
    floor: 35,
    rooms: 6,
    area: 135,
    balconyArea: 21,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_ASE-34-35_select_floor35',
    nrId: 130,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanASE34-35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 234,
    type: 'AWS-35',
    floor: 35,
    rooms: 6,
    area: 166,
    balconyArea: 53,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS-35_select_floor35',
    nrId: 131,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWS35',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 235,
    type: 'AWNE-36',
    floor: 36,
    rooms: 6,
    area: 197,
    balconyArea: 66,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWNE-36_select_floor36',
    nrId: 132,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWNE36',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 236,
    type: 'AES-36',
    floor: 36,
    rooms: 6,
    area: 179,
    balconyArea: 51,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AES-36_select_floor36',
    nrId: 133,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAES36',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 237,
    type: 'AWS-36',
    floor: 36,
    rooms: 5,
    area: 138,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWS-36_select_floor36',
    nrId: 134,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWS36',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 238,
    type: 'AWNE-37',
    floor: 37,
    rooms: 6,
    area: 182,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWNE-37_select_floor37',
    nrId: 135,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWNE37',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 239,
    type: 'AWSE-37',
    floor: 37,
    rooms: 6,
    area: 230,
    balconyArea: 33,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWSE-37_select_floor37',
    nrId: 136,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWSE37',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 240,
    type: 'AWNE-38',
    floor: 38,
    rooms: 6,
    area: 169,
    balconyArea: 105,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWNE-38_select_floor38',
    nrId: 137,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWNE38',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 241,
    type: 'AWSE-38',
    floor: 38,
    rooms: 6,
    area: 182,
    balconyArea: 84,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWSE-38_select_floor38',
    nrId: 138,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWSE38',
    hasVideo: false,
  },
  {
    building: 'A',
    number: 242,
    type: 'AWNES',
    floor: 39,
    rooms: 6,
    area: 180,
    balconyArea: 38,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_AWNES_select_floor39',
    nrId: 139,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanAWNES39',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 2,
    type: 'B2SW',
    floor: 1,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor1',
    nrId: 140,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 5,
    type: 'B5NE',
    floor: 1,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor1',
    nrId: 141,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 6,
    type: 'B6N',
    floor: 1,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor1',
    nrId: 142,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 11,
    type: 'B5NE',
    floor: 2,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor2',
    nrId: 143,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 17,
    type: 'B5NE',
    floor: 3,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor3',
    nrId: 144,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 23,
    type: 'B5NE',
    floor: 4,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor4',
    nrId: 145,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 29,
    type: 'B5NE',
    floor: 5,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor5',
    nrId: 146,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 35,
    type: 'B5NE',
    floor: 6,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor6',
    nrId: 147,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 38,
    type: 'B2SW',
    floor: 7,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor7',
    nrId: 148,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 41,
    type: 'B5NE',
    floor: 7,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor7',
    nrId: 149,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 44,
    type: 'B2SW',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor8',
    nrId: 150,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 47,
    type: 'B5NE',
    floor: 8,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor8',
    nrId: 151,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 48,
    type: 'B6N',
    floor: 8,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor8',
    nrId: 152,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 53,
    type: 'B5NE',
    floor: 9,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor9',
    nrId: 153,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 54,
    type: 'B6N',
    floor: 9,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor9',
    nrId: 154,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 59,
    type: 'B5NE',
    floor: 10,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor10',
    nrId: 155,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 60,
    type: 'B6N',
    floor: 10,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor10',
    nrId: 156,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 63,
    type: 'B3S',
    floor: 11,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor11',
    nrId: 157,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 65,
    type: 'B5NE',
    floor: 11,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor11',
    nrId: 158,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 66,
    type: 'B6N',
    floor: 11,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor11',
    nrId: 159,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 72,
    type: 'B6N',
    floor: 12,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor12',
    nrId: 160,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 77,
    type: 'B5NE',
    floor: 13,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor13',
    nrId: 161,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 78,
    type: 'B6N',
    floor: 13,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor13',
    nrId: 162,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 80,
    type: 'B2SW',
    floor: 14,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor14',
    nrId: 163,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 82,
    type: 'B7SE',
    floor: 14,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B7SE_select_floor14',
    nrId: 164,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB7SE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 83,
    type: 'B5NE',
    floor: 14,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor14',
    nrId: 165,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 84,
    type: 'B6N',
    floor: 14,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor14',
    nrId: 166,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 87,
    type: 'B3S',
    floor: 15,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor15',
    nrId: 167,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 89,
    type: 'B5NE',
    floor: 15,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor15',
    nrId: 168,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 90,
    type: 'B6N',
    floor: 15,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor15',
    nrId: 169,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 93,
    type: 'B3S',
    floor: 16,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor16',
    nrId: 170,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 95,
    type: 'B5NE',
    floor: 16,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor16',
    nrId: 171,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 96,
    type: 'B6N',
    floor: 16,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor16',
    nrId: 172,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 98,
    type: 'B2SW',
    floor: 17,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor17',
    nrId: 173,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 99,
    type: 'B3S',
    floor: 17,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor17',
    nrId: 174,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 101,
    type: 'B5NE',
    floor: 17,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor17',
    nrId: 175,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 104,
    type: 'B2SW',
    floor: 18,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor18',
    nrId: 176,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 105,
    type: 'B3S',
    floor: 18,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor18',
    nrId: 177,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 107,
    type: 'B5NE',
    floor: 18,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor18',
    nrId: 178,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 108,
    type: 'B6N',
    floor: 18,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor18',
    nrId: 179,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 110,
    type: 'B2SW',
    floor: 19,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor19',
    nrId: 180,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 111,
    type: 'B3S',
    floor: 19,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor19',
    nrId: 181,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 113,
    type: 'B5NE',
    floor: 19,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor19',
    nrId: 182,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 114,
    type: 'B6N',
    floor: 19,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor19',
    nrId: 183,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 116,
    type: 'B2SW',
    floor: 20,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor20',
    nrId: 184,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 117,
    type: 'B3S',
    floor: 20,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor20',
    nrId: 185,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 119,
    type: 'B5NE',
    floor: 20,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor20',
    nrId: 186,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 120,
    type: 'B6N',
    floor: 20,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor20',
    nrId: 187,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 122,
    type: 'B2SW',
    floor: 21,
    rooms: 5,
    area: 122,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B2SW_select_floor21',
    nrId: 188,
    tourUrl: 'https://my.treedis.com/tour/rasko-b2sw-2',
    galleryType: 'galleryB2SW',
    galleryCount: 23,
    floorPlanImage: 'floorplanB2SW',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 123,
    type: 'B3S',
    floor: 21,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor21',
    nrId: 189,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 125,
    type: 'B5NE',
    floor: 21,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor21',
    nrId: 190,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 126,
    type: 'B6N',
    floor: 21,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor21',
    nrId: 191,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 129,
    type: 'B3S',
    floor: 22,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor22',
    nrId: 192,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 131,
    type: 'B5NE',
    floor: 22,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor22',
    nrId: 193,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 132,
    type: 'B6N',
    floor: 22,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor22',
    nrId: 194,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 135,
    type: 'B3S',
    floor: 23,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B3S_select_floor23',
    nrId: 195,
    tourUrl: 'https://my.treedis.com/tour/b2s',
    galleryType: 'galleryB3S',
    galleryCount: 18,
    floorPlanImage: 'floorplanB3S',
    hasVideo: true,
  },
  {
    building: 'B',
    number: 137,
    type: 'B5NE',
    floor: 23,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B5NE_select_floor23',
    nrId: 196,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB5NE',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 138,
    type: 'B6N',
    floor: 23,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B6N_select_floor23',
    nrId: 197,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanB6N',
    hasVideo: false,
  },
  {
    building: 'B',
    number: 139,
    type: 'BPHNW',
    floor: 24,
    rooms: 6,
    area: 180,
    balconyArea: 35,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_BPHNW_select_floor24',
    nrId: 198,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'B',
    number: 140,
    type: 'BPHSW',
    floor: 24,
    rooms: 6,
    area: 171,
    balconyArea: 43,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_BPHSW_select_floor24',
    nrId: 199,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'B',
    number: 142,
    type: 'BPHNE',
    floor: 24,
    rooms: 6,
    area: 141,
    balconyArea: 36,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_BPHNE_select_floor24',
    nrId: 200,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'B',
    number: 143,
    type: 'BPHNWE',
    floor: 25,
    rooms: 6,
    area: 158,
    balconyArea: 137,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_BPHNWE_select_floor25',
    nrId: 201,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'B',
    number: 144,
    type: 'BPHSWE',
    floor: 25,
    rooms: 6,
    area: 156,
    balconyArea: 134,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_BPHSWE_select_floor25',
    nrId: 202,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'C',
    number: 5,
    type: 'C5NW',
    floor: 1,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor1',
    nrId: 203,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 11,
    type: 'C5NW',
    floor: 2,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor2',
    nrId: 204,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 17,
    type: 'C5NW',
    floor: 3,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor3',
    nrId: 205,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 29,
    type: 'C5NW',
    floor: 5,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor5',
    nrId: 206,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 35,
    type: 'C5NW',
    floor: 6,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor6',
    nrId: 207,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 39,
    type: 'C3S',
    floor: 7,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor7',
    nrId: 208,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 41,
    type: 'C5NW',
    floor: 7,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor7',
    nrId: 209,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 42,
    type: 'C6N',
    floor: 7,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor7',
    nrId: 210,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 44,
    type: 'C2SE',
    floor: 8,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor8',
    nrId: 211,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 45,
    type: 'C3S',
    floor: 8,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor8',
    nrId: 212,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 47,
    type: 'C5NW',
    floor: 8,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor8',
    nrId: 213,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 48,
    type: 'C6N',
    floor: 8,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor8',
    nrId: 214,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 51,
    type: 'C3S',
    floor: 9,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor9',
    nrId: 215,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 53,
    type: 'C5NW',
    floor: 9,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor9',
    nrId: 216,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 54,
    type: 'C6N',
    floor: 9,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor9',
    nrId: 217,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 57,
    type: 'C3S',
    floor: 10,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor10',
    nrId: 218,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 59,
    type: 'C5NW',
    floor: 10,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor10',
    nrId: 219,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 60,
    type: 'C6N',
    floor: 10,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor10',
    nrId: 220,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 62,
    type: 'C2SE',
    floor: 11,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor11',
    nrId: 221,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 63,
    type: 'C3S',
    floor: 11,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor11',
    nrId: 222,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 65,
    type: 'C5NW',
    floor: 11,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor11',
    nrId: 223,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 66,
    type: 'C6N',
    floor: 11,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor11',
    nrId: 224,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 68,
    type: 'C2SE',
    floor: 12,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor12',
    nrId: 225,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 69,
    type: 'C3S',
    floor: 12,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor12',
    nrId: 226,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 71,
    type: 'C5NW',
    floor: 12,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor12',
    nrId: 227,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 72,
    type: 'C6N',
    floor: 12,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor12',
    nrId: 228,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 74,
    type: 'C2SE',
    floor: 13,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor13',
    nrId: 229,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 75,
    type: 'C3S',
    floor: 13,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor13',
    nrId: 230,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 76,
    type: 'C7SW',
    floor: 13,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor13',
    nrId: 231,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 77,
    type: 'C5NW',
    floor: 13,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor13',
    nrId: 232,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 78,
    type: 'C6N',
    floor: 13,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor13',
    nrId: 233,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 80,
    type: 'C2SE',
    floor: 14,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor14',
    nrId: 234,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 81,
    type: 'C3S',
    floor: 14,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor14',
    nrId: 235,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 82,
    type: 'C7SW',
    floor: 14,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor14',
    nrId: 236,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 83,
    type: 'C5NW',
    floor: 14,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor14',
    nrId: 237,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 84,
    type: 'C6N',
    floor: 14,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor14',
    nrId: 238,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 86,
    type: 'C2SE',
    floor: 15,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor15',
    nrId: 239,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 87,
    type: 'C3S',
    floor: 15,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor15',
    nrId: 240,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 88,
    type: 'C7SW',
    floor: 15,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor15',
    nrId: 241,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 89,
    type: 'C5NW',
    floor: 15,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor15',
    nrId: 242,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 90,
    type: 'C6N',
    floor: 15,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor15',
    nrId: 243,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 92,
    type: 'C2SE',
    floor: 16,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor16',
    nrId: 244,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 93,
    type: 'C3S',
    floor: 16,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor16',
    nrId: 245,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 94,
    type: 'C7SW',
    floor: 16,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor16',
    nrId: 246,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 95,
    type: 'C5NW',
    floor: 16,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor16',
    nrId: 247,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 96,
    type: 'C6N',
    floor: 16,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor16',
    nrId: 248,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 98,
    type: 'C2SE',
    floor: 17,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor17',
    nrId: 249,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 99,
    type: 'C3S',
    floor: 17,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor17',
    nrId: 250,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 100,
    type: 'C7SW',
    floor: 17,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor17',
    nrId: 251,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 101,
    type: 'C5NW',
    floor: 17,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor17',
    nrId: 252,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 102,
    type: 'C6N',
    floor: 17,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor17',
    nrId: 253,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 104,
    type: 'C2SE',
    floor: 18,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor18',
    nrId: 254,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 105,
    type: 'C3S',
    floor: 18,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor18',
    nrId: 255,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 106,
    type: 'C7SW',
    floor: 18,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor18',
    nrId: 256,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 107,
    type: 'C5NW',
    floor: 18,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor18',
    nrId: 257,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 108,
    type: 'C6N',
    floor: 18,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor18',
    nrId: 258,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 110,
    type: 'C2SE',
    floor: 19,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor19',
    nrId: 259,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 111,
    type: 'C3S',
    floor: 19,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor19',
    nrId: 260,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 113,
    type: 'C5NW',
    floor: 19,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor19',
    nrId: 261,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 114,
    type: 'C6N',
    floor: 19,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor19',
    nrId: 262,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 116,
    type: 'C2SE',
    floor: 20,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor20',
    nrId: 263,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 117,
    type: 'C3S',
    floor: 20,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor20',
    nrId: 264,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 118,
    type: 'C7SW',
    floor: 20,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor20',
    nrId: 265,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 119,
    type: 'C5NW',
    floor: 20,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor20',
    nrId: 266,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 120,
    type: 'C6N',
    floor: 20,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor20',
    nrId: 267,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 122,
    type: 'C2SE',
    floor: 21,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor21',
    nrId: 268,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 123,
    type: 'C3S',
    floor: 21,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor21',
    nrId: 269,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 125,
    type: 'C5NW',
    floor: 21,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor21',
    nrId: 270,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 126,
    type: 'C6N',
    floor: 21,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor21',
    nrId: 271,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 128,
    type: 'C2SE',
    floor: 22,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor22',
    nrId: 272,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 129,
    type: 'C3S',
    floor: 22,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor22',
    nrId: 273,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 131,
    type: 'C5NW',
    floor: 22,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor22',
    nrId: 274,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 132,
    type: 'C6N',
    floor: 22,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor22',
    nrId: 275,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 134,
    type: 'C2SE',
    floor: 23,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor23',
    nrId: 276,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 135,
    type: 'C3S',
    floor: 23,
    rooms: 3,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C3S_select_floor23',
    nrId: 277,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC3S',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 136,
    type: 'C7SW',
    floor: 23,
    rooms: 4,
    area: 98,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C7SW_select_floor23',
    nrId: 278,
    tourUrl: 'https://my.treedis.com/tour/c7sw',
    galleryType: 'galleryC7SW',
    galleryCount: 14,
    floorPlanImage: 'floorplanC7SW',
    hasVideo: true,
  },
  {
    building: 'C',
    number: 137,
    type: 'C5NW',
    floor: 23,
    rooms: 5,
    area: 121,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C5NW_select_floor23',
    nrId: 279,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC5NW',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 138,
    type: 'C6N',
    floor: 23,
    rooms: 5,
    area: 124,
    balconyArea: 16,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C6N_select_floor23',
    nrId: 280,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC6N',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 139,
    type: 'CPHNE',
    floor: 24,
    rooms: 5,
    area: 133,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_CPHNE_select_floor24',
    nrId: 281,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'C',
    number: 140,
    type: 'C2SE',
    floor: 24,
    rooms: 5,
    area: 122,
    balconyArea: 14,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_C2SE_select_floor24',
    nrId: 282,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    galleryCount: 3,
    floorPlanImage: 'floorplanC2SE',
    hasVideo: false,
  },
  {
    building: 'C',
    number: 141,
    type: 'CPHSW',
    floor: 24,
    rooms: 6,
    area: 152,
    balconyArea: 37,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_CPHSW_select_floor24',
    nrId: 283,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'C',
    number: 142,
    type: 'CPHNW',
    floor: 24,
    rooms: 6,
    area: 183,
    balconyArea: 64,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_CPHNW_select_floor24',
    nrId: 284,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'C',
    number: 143,
    type: 'CPHNWE',
    floor: 25,
    rooms: 6,
    area: 175,
    balconyArea: 113,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_CPHNWE_select_floor25',
    nrId: 285,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
  {
    building: 'C',
    number: 144,
    type: 'CPHSEWE',
    floor: 25,
    rooms: 6,
    area: 180,
    balconyArea: 119,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C_CPHSEWE_select_floor25',
    nrId: 286,
    tourUrl: undefined,
    galleryType: undefined,
    galleryCount: undefined,
    floorPlanImage: undefined,
    hasVideo: false,
  },
];
